import React, { PureComponent } from 'react'
import * as rn from 'react-native'
import theme from '../../../styles/theme'

export const fontSizes = {
  huger: 50,
  hugehack: 46,
  huge: 40,
  xxxl: 35,
  xxl: 28,
  xl: 24,
  l: 22,
  m: 18,
  s: 16,
  xs: 14,
  xxs: 10
}

export class Text extends PureComponent {
  render () {
    const {
      // Font props
      italic,
      bold,
      medium,
      light,
      logo,
      proxima,
      proximaBold,
      semibold,
      raleway,
      uppercase,

      // Colour props
      primary,
      white,
      darkgrey,
      colour,

      size,
      fontSize,
      children,
      rotate,
      center,
      right,

      overrides,
      link,
      href
    } = this.props

    const textProps = {}

    if (link) {
      textProps.accessibilityRole = 'link'
    }

    if (href) {
      textProps.href = href
      textProps.target = '_blank'
    }

    const styles = [{
      fontFamily: logo ? 'sf-orson-casual-light' : 'ubuntu',
      fontSize: 18,
      color: theme.colours.black
    }]

    if (bold) {
      styles.push({ fontFamily: 'ubuntu-bold' })
    }

    if (medium) {
      styles.push({ fontFamily: 'ubuntu-medium' })
    }

    if (light) {
      styles.push({ fontFamily: 'ubuntu-light' })
    }

    if (proxima) {
      styles.push({ fontFamily: 'proxima' })
    }

    if (proximaBold) {
      styles.push({ fontFamily: 'proxima-bold' })
    }

    if (semibold) {
      styles.push({ fontFamily: 'opensans-semibold' })
    }

    if (raleway) {
      styles.push({ fontFamily: 'raleway' })
    }

    if (primary) {
      styles.push({ color: theme.colours.primary })
    }

    if (white) {
      styles.push({ color: theme.colours.white })
    }

    if (darkgrey) {
      styles.push({ color: theme.colours.darkgrey })
    }

    if (size) {
      styles.push({ fontSize: fontSizes[size] || 18 })
    }

    if (fontSize) {
      styles.push({ fontSize })
    }

    if (italic) {
      styles.push({ fontStyle: 'italic' })
    }

    if (rotate) {
      styles.push({
        transform: [{ rotate }]
      })
    }

    if (center) {
      styles.push({ textAlign: 'center' })
    }

    if (right) {
      styles.push({ textAlign: 'right' })
    }

    if (colour) {
      styles.push({ color: colour })
    }

    if (uppercase) {
      styles.push({ textTransform: 'uppercase' })
    }

    if (overrides) {
      styles.push(overrides)
    }

    return (
      <rn.Text style={styles} {...textProps}>
        {children}
      </rn.Text>
    )
  }
}
